import { VET_ADVICE_STRIPE_URL, WEBSITE_DOMAIN } from '@application/constants';
import { useModal, useRouter } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import { VetAdviceModal } from '@presentation/components';
import { useCallback } from 'react';
import { singletonHook } from 'react-singleton-hook';

const init: ReturnType<typeof useVetAdviceModalSingleton> = {
  modalHook: {
    show: () => undefined,
    showFromClick: () => undefined,
    close: () => undefined,
    modal: {
      onCloseClick: undefined,
      open: false,
      position: [0, 0],
    },
  },
};

export const useVetAdviceModalSingleton = () => {
  const modalHook = useModal({});

  return {
    modalHook,
  };
};

export const useVetAdviceModal = singletonHook(init, useVetAdviceModalSingleton);

export const VetAdviceModalController = () => {
  const { language, countryCode, translatedRoute } = useRouter();
  const { modalHook } = useVetAdviceModal();

  const onConfirmClickHandler = useCallback(() => {
    const successUrl = `${WEBSITE_DOMAIN}${translatedRoute('thankyou')}?status=success`;
    const cancelUrl = `${WEBSITE_DOMAIN}${translatedRoute('homeLanding')}`;
    const targetUrl = `${VET_ADVICE_STRIPE_URL}?partner=tipaw&service=behavior&country=${countryCode}&language=${language}&success_url=${encodeURI(
      successUrl,
    )}&cancel_url=${encodeURI(cancelUrl)}`;

    setTimeout(() => {
      modalHook.close();
    }, 1000);
    Analytics.sendClickOnVetAdviceWhatsappButton();
    window?.open(targetUrl, '_blank');
  }, [countryCode, language, modalHook, translatedRoute]);

  return <VetAdviceModal modal={modalHook?.modal} onConfirm={onConfirmClickHandler} />;
};
